import { CheckPicker, SelectPicker } from "rsuite";

import useGlobalLists from "../../../api/api-hooks/cloud/useGlobalLists";
import { Module, StageProgressSection } from "../../../types/TenantInterfaces";
import ManageItems from "../../ManageItems/ManageItems";
import WidgetSection from "./WidgetSection";

interface Props {
  section: StageProgressSection;
  i: number;
  reorderSection: (section: StageProgressSection, i: number) => void;
  sectionsLength: number;
  editMode: boolean;
  removeSection: (id: string) => void;
  infoChange: (e: any, section: StageProgressSection) => void;
  currentModule: Module;
  removeStage: (
    section: StageProgressSection,
    stage: { Stage: string } | "All"
  ) => void;
  fieldListUpdate: (newOrder: string[], section: StageProgressSection) => void;
  onSelectStage: (section: StageProgressSection, stage: string) => void;
  selectedStages: string[];
  handleProgressFieldChange?: (evt: any, section: StageProgressSection) => void;
}

// Section used in RecordDetailLayout when the section type is StageProgress
export const StageProgress = ({
  section,
  i,
  reorderSection,
  sectionsLength,
  editMode,
  removeSection,
  infoChange,
  currentModule,
  removeStage,
  fieldListUpdate,
  onSelectStage,
  selectedStages,
  handleProgressFieldChange,
}: Props) => {
  const { globalLists } = useGlobalLists(!!section.ProgressField);

  return (
    <WidgetSection
      editMode={editMode}
      reorderSection={reorderSection}
      section={section}
      index={i}
      sectionsLength={sectionsLength}
      removeSection={removeSection}
      infoChange={infoChange}
      body={
        <>
          <h5 className="text-uppercase">Progress Field</h5>
          {editMode ? (
            <SelectPicker
              value={section?.ProgressField}
              searchable={false}
              placeholder="Select A Field"
              data={
                Array.isArray(currentModule?.Fields)
                  ? currentModule.Fields.filter(
                      (f) => f?.FieldType === "SingleSelect"
                    )
                  : []
              }
              labelKey="Name"
              valueKey="APIName"
              block
              onChange={(val) => {
                const mockInputEvent = {
                  target: {
                    name: `ProgressField${section.id}`,
                    value: val,
                  },
                };

                handleProgressFieldChange &&
                  handleProgressFieldChange(mockInputEvent, section);
              }}
              cleanable={false}
            />
          ) : (
            section?.ProgressField
          )}

          <h5 className="text-uppercase mt-4 mb-3">Stages</h5>
          {editMode ? (
            <>
              <ManageItems
                items={section.Stages}
                idKey="Stage"
                nameKey="Stage"
                itemKey={undefined}
                onDelete={({ id }) => removeStage(section, { Stage: id })}
                onReorder={({ newOrder }) => fieldListUpdate(newOrder, section)}
              />
              <CheckPicker
                className="mt-4"
                placeholder="Select Layout Stages"
                data={getAvailableStages(globalLists)}
                labelKey="Name"
                valueKey="Value"
                value={selectedStages}
                onSelect={(_, s) => onSelectStage(section, s?.Value)}
                block
                preventOverflow
                onClean={() => removeStage(section, "All")}
              />
            </>
          ) : (
            <div>
              {section.Stages?.map((stage: any, i: number) => (
                <div key={i}>
                  <small>{stage.Stage}</small>
                </div>
              ))}
            </div>
          )}
        </>
      }
    />
  );

  function getAvailableStages(globalLists: any[] | undefined) {
    if (!currentModule?.Fields || !section?.ProgressField) return [];

    const field = currentModule.Fields.find(
      (f) => f.APIName === section.ProgressField
    );

    if (typeof field?.SourcesList === "string" && globalLists) {
      const listName = field.SourcesList.replace("Global.Lists.", "");
      const globalList = globalLists.find((l) => l?.Name === listName);

      return globalList?.Variables ?? [];
    }

    return Array.isArray(field?.SourcesList) ? field.SourcesList : [];
  }
};
